import { createAsyncThunk } from "@reduxjs/toolkit";
import { IGeneratedPremiumReport, IMyRenewals } from "./myRenewals.types";
import { APIError } from "../../constants/types";
import { api } from "../../api/api";
import { ERROR_MESSAGES } from "../../constants/enums";
import { generateAdvanceFilterQuery } from "../Accounting/AccountingReports/AccountingReportsActions";

export const fetchMyRenewalsList = createAsyncThunk<
  {
    data: IMyRenewals[];
  },
  {
    pageNumber: number;
    rowsInPerPage: number;
    limit: number;
    searchState: { [key: string]: any };
  },
  { rejectValue: APIError }
>(
  "myRenewals/fetchMyRenewalsList",
  async (
    { pageNumber, rowsInPerPage, limit, searchState },
    { rejectWithValue },
  ) => {
    try {
      const { from_date, to_date, ...finalSearchState } = searchState;
      const query = generateAdvanceFilterQuery(finalSearchState);
      let finalUrl = `/accounting/get-premium-report-logs?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}`;
      if (query) {
        finalUrl = finalUrl + "&" + query;
      }
       if (from_date) {
        const filterObj = {
          column: ["creation_date"],
          operator: "GREATER_THAN_EQUAL",
          value: from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (to_date) {
        const filterObj = {
          column: ["creation_date"],
          operator: "LESSER_THAN_EQUAL",
          value: to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }
      const res = await api.get(finalUrl);
      const data: IMyRenewals[] = res.data.data;
      return {
        data,
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);


export const fetchGeneratedPremiumReportList = createAsyncThunk<
  {
    data: IGeneratedPremiumReport[];
  },
  {
    report_log_code: string;
    pageNumber: number;
    rowsInPerPage: number;
    limit: number;
    searchState: { [key: string]: any };
  },
  { rejectValue: APIError }
>(
  "myRenewals/fetchGeneratedPremiumReportList",
  async (
    { report_log_code,pageNumber, rowsInPerPage, limit, searchState },
    { rejectWithValue },
  ) => {
    try {
      const { from_date, to_date, ...finalSearchState } = searchState;
      const query = generateAdvanceFilterQuery(finalSearchState);
      let finalUrl = `/accounting/get-premium-generated-report?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&report_log_code=${report_log_code}`;
      if (query) {
        finalUrl = finalUrl + "&" + query;
      }
      const res = await api.get(finalUrl);
      const data: IGeneratedPremiumReport[] = res.data.data;
      return {
        data,
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);

export const upsertGeneratedPremiumReport = createAsyncThunk<
  {
    data: IGeneratedPremiumReport;
  },
  {
    payload: Partial<IGeneratedPremiumReport>;
  },
  { rejectValue: APIError }
>(
  "myRenewals/upsertGeneratedPremiumReport",
  async ({ payload }, { rejectWithValue }) => {
    try {
      const res = await api.post(`/accounting/upsert-premium-generated-report`, payload);
      const data: IGeneratedPremiumReport = res.data.data;
      return {
        data,
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);